import { render } from "./AddProduct.vue?vue&type=template&id=2464f668&scoped=true"
import script from "./AddProduct.vue?vue&type=script&lang=js"
export * from "./AddProduct.vue?vue&type=script&lang=js"

import "./AddProduct.vue?vue&type=style&index=0&id=2464f668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2464f668"]])

export default __exports__